export const recurrenceTypes = [
    {
        id: 1,
        code: 'return',
        label: 'Return',
    },
    {
        id: 2,
        code: 'time',
        label: 'Time',
    },
    {
        id: 3,
        code: 'cycle',
        label: 'Cycle',
    },
    {
        id: 4,
        code: 'onDemand',
        label: "On Demand"
    }
];
